import { Trans } from 'react-i18next';
import LOCALS from './locals';

export const findLabelByValue = (
  value: any,
  options: { value: string | number; label: any }[],
  defaultData?: { value: string | number; label: any },
) => {
  const t = options.find((i) => i.value === value);
  if (t) return t.label;
  if (defaultData) return defaultData.label;
  return '-';
};

export const OMS_RECYCLE_ORDER_TYPE_MAP = {
  // 未确认
  UNCONFIRMED: 0,
  // 寄卖
  CONSIGNMENT: 1,
  // 回收
  RECYCLE: 2,
};

export const OMS_RECYCLE_ORDER_TYPE_LIST = [
  {
    value: OMS_RECYCLE_ORDER_TYPE_MAP.UNCONFIRMED,
    label: <Trans i18nKey={LOCALS.unconfirmed} />,
  },
  {
    value: OMS_RECYCLE_ORDER_TYPE_MAP.CONSIGNMENT,
    label: <Trans i18nKey={LOCALS.consignment} />,
  },
  {
    value: OMS_RECYCLE_ORDER_TYPE_MAP.RECYCLE,
    label: <Trans i18nKey={LOCALS.sell} />,
  },
];

export const OMS_RECYCLE_ORDER_PRIORITY_MAP = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
};

export const OMS_RECYCLE_ORDER_PRIORITY_OPTION_LIST = [
  {
    value: OMS_RECYCLE_ORDER_PRIORITY_MAP.LOW,
    label: (
      <div className="bg-[#81D3F8] py-1 px-2 rounded text-xs cursor-pointer w-16 inline-block text-center">
        Low
      </div>
    ),
  },
  {
    value: OMS_RECYCLE_ORDER_PRIORITY_MAP.MEDIUM,
    label: (
      <div className="bg-[#FACD91] py-1 px-2 rounded text-xs cursor-pointer w-16 inline-block text-center">
        Medium
      </div>
    ),
  },
  {
    value: OMS_RECYCLE_ORDER_PRIORITY_MAP.HIGH,
    label: (
      <div className="bg-[#D9001B] text-white py-1 px-2 rounded text-xs cursor-pointer w-16 inline-block text-center">
        High
      </div>
    ),
  },
];

export enum CHECKOUT_OUT_PRODUCT_PRICE_TYPE {
  WITH_TAX = 'with_tax',
  WITH_OUT_TAX = 'without_tax',
}

export const CHECKOUT_OUT_PRODUCT_PRICE_TYPE_OPTION_LIST = [
  {
    value: CHECKOUT_OUT_PRODUCT_PRICE_TYPE.WITH_TAX,
    label: <Trans i18nKey={LOCALS.tax_inclusive} />,
  },
  {
    value: CHECKOUT_OUT_PRODUCT_PRICE_TYPE.WITH_OUT_TAX,
    label: <Trans i18nKey={LOCALS.tax_free} />,
  },
];

export const INTEGRAL_MAP = {
  REGISTRATION: 'REGISTRATION',
  ORDER: 'ORDER',
};

export const INTEGRAL_OPTION_LIST = [
  {
    value: INTEGRAL_MAP.REGISTRATION,
    label: <Trans i18nKey={LOCALS.registrationPoints} />,
  },
  { value: INTEGRAL_MAP.ORDER, label: <Trans i18nKey={LOCALS.orderPoints} /> },
];

export const SMS_COUPON_TYPE = {
  NORMAL: 0,
  REGISTER_CODE: 3, // 注册送券
  SPECIAL_CODE: 4, // 特殊类型的优惠券，一段时间内开放，只能用一次
};

export const SMS_COUPON_TYPE_OPTION_LIST = [
  {
    value: SMS_COUPON_TYPE.NORMAL,
    label: '普通优惠券',
  },
  {
    value: SMS_COUPON_TYPE.REGISTER_CODE,
    label: '注册优惠券',
  },
  {
    value: SMS_COUPON_TYPE.SPECIAL_CODE,
    label: '期限优惠券',
  },
];

/**
 * @description 商品库存状态流转图
 * @link https://www.figma.com/board/2rvgHDgiw5hxZFpjCJabPH/product_inventory_status?node-id=0-1&node-type=canvas&t=9VDodc3upMAqEpe8-0
 */
export enum PMS_PRODUCT_STOCK_STATUS {
  PENDING_ENTRY = 'PENDING_ENTRY', // -- 待入库
  STOCKED = 'STOCKED', // 已入库
  FOR_SALE = 'FOR_SALE', // 售卖中
  RESERVED = 'RESERVED', // 预留中
  LENT_OUT = 'LENT_OUT', // 已借出
  SOLD = 'SOLD', // 已售出
  INVALID = 'INVALID', // 无效库存
  RENTAL_STOCK = 'RENTAL_STOCK', // 租借库存
}

export const PMS_PRODUCT_STOCK_STATUS_OPTION_LIST = [
  {
    value: PMS_PRODUCT_STOCK_STATUS.PENDING_ENTRY,
    label: <Trans i18nKey={LOCALS.cWgwnQtBhq}></Trans>,
    labelKey: LOCALS.cWgwnQtBhq,
  },
  {
    value: PMS_PRODUCT_STOCK_STATUS.STOCKED,
    label: <Trans i18nKey={LOCALS.tPZNlIoLIJ}></Trans>,
    labelKey: LOCALS.tPZNlIoLIJ,
  },
  {
    value: PMS_PRODUCT_STOCK_STATUS.FOR_SALE,
    label: <Trans i18nKey={LOCALS.ZNabMrkXeR}></Trans>,
    labelKey: LOCALS.ZNabMrkXeR,
  },
  {
    value: PMS_PRODUCT_STOCK_STATUS.LENT_OUT,
    label: <Trans i18nKey={LOCALS.qjvTkFPhtS}></Trans>,
    labelKey: LOCALS.qjvTkFPhtS,
  },
  {
    value: PMS_PRODUCT_STOCK_STATUS.RESERVED,
    label: <Trans i18nKey={LOCALS.gCfzSuAAFu}></Trans>,
    labelKey: LOCALS.gCfzSuAAFu,
  },
  {
    value: PMS_PRODUCT_STOCK_STATUS.SOLD,
    label: <Trans i18nKey={LOCALS.JTehSPdAjL}></Trans>,
    labelKey: LOCALS.JTehSPdAjL,
  },
  {
    value: PMS_PRODUCT_STOCK_STATUS.INVALID,
    label: <Trans i18nKey={LOCALS.aDOEGIrhvq}></Trans>,
    labelKey: LOCALS.aDOEGIrhvq,
  },
  {
    value: PMS_PRODUCT_STOCK_STATUS.RENTAL_STOCK,
    label: <Trans i18nKey={LOCALS.WxlSBxBgJG}></Trans>,
    labelKey: LOCALS.WxlSBxBgJG,
  },
];


export const OrderDeliveryTypeMap = {
  DELIVERY: 'DELIVERY', // 邮寄
  PICKUP: 'PICKUP', // 自提
};

export const OrderDeliveryTypeOptionList = [
  {
    value: OrderDeliveryTypeMap.DELIVERY,
    label: <Trans i18nKey={LOCALS.arvArlFrfX}></Trans>,
  },
  {
    value: OrderDeliveryTypeMap.PICKUP,
    label: <Trans i18nKey={LOCALS.xCWNaTSMxQ}></Trans>,
    color: '#ed5a65',
  },
];

export const PRODUCT_STOCK_TYPE = {
  SINGLE: 0,
  MULTI: 1,
};

export const PRODUCT_STOCK_TYPE_OPTION_LIST = [
  {
    value: PRODUCT_STOCK_TYPE.SINGLE,
    labelKey: LOCALS.KDYOlENnJC,
  },
  {
    value: PRODUCT_STOCK_TYPE.MULTI,
    labelKey: LOCALS.rtjLykJLYo,
  },
];
